// Ask Vera usage stats (VRG-227) — react-query hook for the internal /internal/ask-stats
// page. Mirrors useTourAnalytics.ts's shape exactly.
import { useQuery } from '@tanstack/react-query'

import { askStatsApi } from 'services'

/**
 * All-time cross-company Ask Vera usage stats (bounded naturally by the 90-day
 * retention window, not an additional client-side one).
 *
 * `staleTime` 5 minutes: this is a staff monitoring page, not a live dashboard, so a
 * tab switch re-rendering from cache rather than re-aggregating on every click is the
 * right trade. `retry: false` — a 403 (no `internal_support_manage`) is a settled
 * answer, not a transient failure.
 */
export const useAskStats = () =>
  useQuery({
    queryKey: ['internal', 'ask-stats'],
    queryFn: () => askStatsApi.stats(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
